import { useEffect, useState } from 'react';

// Returns a perctage of position down the page
const useScrollPosition = () => {
  const [percentageScrolled, setPercentageScrolled] = useState(0);
  const [windowScrollY, setWindowScrollY] = useState(0);

  const updatePosition = () => {
    setPercentageScrolled(window.scrollY / (document.body.scrollHeight - window.innerHeight));

    setWindowScrollY(window.scrollY);
  };

  useEffect(() => {
    updatePosition();
    window.addEventListener('scroll', updatePosition);
    return () => window.removeEventListener('scroll', updatePosition);
  }, []);

  return { percentageScrolled, windowScrollY };
};

export default useScrollPosition;
